/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_act_active = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active (6–7 days/week)`)
};

const es_bmr_act_active = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo (6–7 días/semana)`)
};

const de_bmr_act_active = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv (6–7 Tage/Woche)`)
};

const nl_bmr_act_active = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actief (6–7 dagen/week)`)
};

const fr_bmr_act_active = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actif (6-7 jours/semaine)`)
};

const it_bmr_act_active = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attivo (6–7 giorni/settimana)`)
};

const pt_br2_bmr_act_active = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativo (6–7 dias/semana)`)
};

const pt_bmr_act_active = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativo (6–7 dias/semana)`)
};

const ja_bmr_act_active = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活発（週6～7日）`)
};

const zh_bmr_act_active = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活跃（每周 6–7 天）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_act_active = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_act_active(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_act_active", locale)
	if (locale === "en") return en_bmr_act_active(inputs)
	if (locale === "es") return es_bmr_act_active(inputs)
	if (locale === "de") return de_bmr_act_active(inputs)
	if (locale === "nl") return nl_bmr_act_active(inputs)
	if (locale === "fr") return fr_bmr_act_active(inputs)
	if (locale === "it") return it_bmr_act_active(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_act_active(inputs)
	if (locale === "pt") return pt_bmr_act_active(inputs)
	if (locale === "ja") return ja_bmr_act_active(inputs)
	return zh_bmr_act_active(inputs)
};